import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators }  from 'redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {
	CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  INITIALIZE,
  INITIALIZE_SUCCESS,
  INITIALIZE_FAILURE
} from 'constants/ActionTypes';

import { changePassword, initialize } from 'api/actions';

import Input from 'components/Input';
import Button from 'components/Button';
import Spacer from 'components/Spacer';

import { auth } from 'utils'

import SettingContainer from './settingContainer';

import './index.css';

class Settings extends React.Component {
	state = {}

	componentWillReceiveProps(nextProps) {
		switch (nextProps.type) {
      case CHANGE_PASSWORD:
      	this.showLoading();
        break;
      case CHANGE_PASSWORD_SUCCESS:
      	this.hideLoading();

      	auth.signOut();
      	window.location = '/';

        break;
      case CHANGE_PASSWORD_FAILURE:
      	this.hideLoading();
        break;
      case INITIALIZE:
      	this.showLoading();
        break;
      case INITIALIZE_SUCCESS:
      	this.hideLoading();

      	this.props.addNotification({
	        message: 'Initialization successful. You are good to go!!!',
	        level: 'success',
	        autoDismiss: 10
	      })
        break;
      case INITIALIZE_FAILURE:
      	this.hideLoading();
        break;  
    }
	}

	showLoading = () => this.props.showLoading && this.props.showLoading();
	
	hideLoading = () => this.props.hideLoading && this.props.hideLoading();


	toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

	render() {
		return (
			<div className={'settings-container'}>
				<SettingContainer title={'Change Password'} theme={'minimal'}>
					<p>
						You will be logged out if you change the password.
					</p>
					<form
						onSubmit={(e) => {
							e.preventDefault();
							e.stopPropagation();
							this.props.changePassword(this.state)
						}}
					>
						<Input
							type={'password'}
							required
							placeholder={'Old Password'}
							onChange={(e => this.setState({ opassword: e.target.value }))}
						/>
						<Spacer size={'sm'} />
						<Input
							type={'password'}
							required
							placeholder={'New Password'}
							onChange={(e => this.setState({ password: e.target.value }))}
						/>
						<Spacer size={'sm'} />
						<Button
							submit
	       			label={'Set password'}
	        	/>
					</form>
				</SettingContainer>

				<Spacer size={'md'} />
				<Spacer size={'md'} />

				<hr />

				<Spacer size={'md'} />
				<Spacer size={'md'} />

				<SettingContainer title={'Restart'} theme={'danger'}>
					<h6>
						Please read carefully
					</h6>
					<p>
						Pressing the button below will reinitialize your deployment and purge all the data stored in the database.
						It will also do a fresh scan of your s3 bucket and index it.
					</p>
					<p>
						This will likely take some time, so please be patient and don't close the tab.
					</p>
					<Button
            onClick={() => {
              this.toggle()
            }}
         		label={'Restart'}
         		theme={'danger'}
        	/>
				</SettingContainer>
				<Modal isOpen={this.state.modal} toggle={this.toggle} modalClassName='modal-container'>
          <ModalBody>
            <div className='modal-body'>
            	<h5>Are you sure you want to restart</h5>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button 
            	onClick={() => {
            		this.toggle();
            		this.props.initialize(this.state);
            	}}
            	theme={'danger'}
            >
            	Yes
            </Button>
          </ModalFooter>
        </Modal>
			</div>
		);
	}
}

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ changePassword, initialize }, dispatch)
};

const mapStateToProps = (state) => ({
  errorMessage: state.errorMessage,
  type: state.type
});

export default connect(mapStateToProps, dispatchToProps)(
  Settings
);